module.exports = __webpack_public_path__ + "static/media/GrayFolder.e26137ce.svg";